export default __webpack_public_path__ + "static/media/Thumbnail1.9579942f.jpg";